<template>
  <div>
    <table-card
      :items="companies"
      :fields="[ 'id', 'name', 'settings' ]"
      title="Partner Companies">

      <template v-slot:cell(id)="data">
        <b-badge>{{ data.value }}</b-badge>
      </template>
      <template v-slot:cell(settings)="data">
        <div class="hidden-button-group float-right">
          <icon-button :to="{ name: 'AdminCompanyProfile', params: { cid: data.item.id }}" icon="icon-Settings"
                       variant="outline-border" tooltip="Settings"></icon-button>
        </div>
      </template>
    </table-card>

    <div class="row text-left">
      <div class="col-sm">
        <b-btn type="button" :to="{ name: 'AdminCompanyCreate' }" variant="primary" class="my-3 mx-0">
          + New Company
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
    import TableCard from '@/components/TableCard'
  import { CompanyApi } from '@/company/api'

  export default {
      created () {
        CompanyApi.list().then((list) => {
            this.companies = list
        })
      },
      data () {
          return {
              companies: []
          }
      },
      components: {
          TableCard
      }
  }
</script>



// WEBPACK FOOTER //
// src/admin/pages/CompanyList.vue